import type { OverlayTheme } from '../services/api';

/** Rótulos dos templates de alerta para a galeria da dashboard. */
export const TEMPLATE_LABELS: Record<OverlayTheme['template'], string> = {
  classic: 'Clássico',
  minimal: 'Minimalista',
  banner: 'Faixa',
  neon: 'Neon',
  bubble: 'Balão',
  pill: 'Pílula',
  retro: 'Retrô',
  seal: 'Selo',
  custom: 'HTML próprio',
};
